import React, { useState, memo, useEffect, Fragment } from "react";
import axios from 'axios';
import { useRecoilState, useRecoilValue } from "recoil";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { SubmitButton } from '../parts/SubmitButton';

import { examOrderState } from '../../../store/examOrderState';
import { currentStatusState } from '../../../store/currentStatusState';

export const FormIneligible = memo((props) => {
  const { user, staff_user } = props;
  const [examOrderData, setExamOrderData] = useRecoilState(examOrderState);
  const [currentStatus, setCurrentStatus] = useRecoilState(currentStatusState);

  const notify = (type, message) => {
    if (type === "success") {
      toast.success(message, {
        hideProgressBar: true
      });
    } else {
      toast.error(message, {
        hideProgressBar: true
      });
    }
  }

  const onChangeStatus = (e) => {
    setCurrentStatus(e.target.value);
  }

  const onClickOrderNotIneligible = () => {
    const sure = window.confirm('Are you sure to order not ineligible ?');
    if (sure) {
      var data = {
        proxy_checkup: {
          fix_staff_users_id: staff_user,
          mtemployee_id: user.id,
          status: currentStatus,
          cource_code: 0,
        },
        employee_id: user.id,
      };

      // axios csrfToken
      const csrfToken = document.querySelector('[name=csrf-token]').content
      axios.defaults.headers.common['X-CSRF-Token'] = csrfToken
  
      axios.post(`/agent/employees/${user.id}/order_not_ineligible`, data)
      .then(resp => {
        console.log("Proxy order_not_ineligible api ok");
        console.log(resp.data);
        setExamOrderData({
          ...examOrderData,
          id: resp.data.id,
          status: resp.data.status,
        });
        setCurrentStatus(resp.data.status);
        notify("success", "対象外 Create Success!");
      })
      .catch(e => {
        console.log("Proxy order_not_ineligible api ng");
        console.log(e.response);
        setCurrentStatus("");
        alert(JSON.parse(e.request.responseText).errors);
        notify("error", "対象外 Create Error!");
      });
    }
  }

  const stateDisplay = () => {
    return (
      <div className="input-group mb-3">
        <label className="input-group-text" htmlFor="todofukenselect">ステータス</label>
        <select value={currentStatus} className="form-select" aria-label="Default select edit" id="statusselect" onChange={onChangeStatus} >
          <option value="" disabled></option>
          <option value="order_not_ineligible">対象外（未受診）</option>
          <option value="order_not_ineligible_retired">対象外（退職）</option>
          <option value="order_not_ineligible_leave">対象外（産育休）</option>
          <option value="order_not_ineligible_exception">結果票待（提携外）</option>
        </select>
      </div>
    )
  }

  return (
    <>
      { stateDisplay() }
      <SubmitButton 
        text="送信"
        onClick={onClickOrderNotIneligible}
        isDisabledVal={currentStatus ? false : true}
      />
    </>
  );
});